import type {COTABD} from "../../types";

// COTABDs — Classes of Transactions, Account Balances, and Disclosures
export const COTABDS: COTABD[] = [
  // Expenditures
  {
    id: "cotabd-exp-transactions",
    name: "Purchase transactions",
    type: "transaction",
    fsaId: "expenditures",
    assertionIds: ["existence", "completeness", "accuracy", "cutoff"],
    processIds: ["proc-vendor-invoice", "proc-expense-reimbursement", "proc-corp-card"],
    material: true,
    significant: true,
  },
  {
    id: "cotabd-exp-balance",
    name: "Accounts payable balance",
    type: "balance",
    fsaId: "expenditures",
    assertionIds: ["existence", "completeness", "valuation", "rights"],
    processIds: ["proc-vendor-invoice"],
    material: true,
    significant: false,
  },
  {
    id: "cotabd-exp-disclosure",
    name: "Expenditure disclosures",
    type: "disclosure",
    fsaId: "expenditures",
    assertionIds: ["completeness", "accuracy", "presentation"],
    processIds: ["proc-vendor-invoice", "proc-expense-reimbursement"],
    material: false,
    significant: true,
  },
  // Revenue
  {
    id: "cotabd-rev-transactions",
    name: "Revenue transactions",
    type: "transaction",
    fsaId: "revenue",
    assertionIds: ["existence", "completeness", "accuracy", "cutoff"],
    processIds: ["proc-order-fulfillment", "proc-contract-rev-rec"],
    material: true,
    significant: true,
  },
  {
    id: "cotabd-rev-balance",
    name: "Accounts receivable balance",
    type: "balance",
    fsaId: "revenue",
    assertionIds: ["existence", "completeness", "valuation", "rights"],
    processIds: ["proc-credit-collections"],
    material: true,
    significant: false,
  },
  {
    id: "cotabd-rev-disclosure",
    name: "Revenue recognition disclosures",
    type: "disclosure",
    fsaId: "revenue",
    assertionIds: ["completeness", "accuracy", "presentation"],
    processIds: ["proc-contract-rev-rec"],
    material: false,
    significant: true,
  },
  // Financial Reporting
  {
    id: "cotabd-fr-transactions",
    name: "Journal entry transactions",
    type: "transaction",
    fsaId: "financial-reporting",
    assertionIds: ["existence", "completeness", "accuracy", "cutoff"],
    processIds: ["proc-journal-entry"],
    material: true,
    significant: true,
  },
  {
    id: "cotabd-fr-balance",
    name: "General ledger balances",
    type: "balance",
    fsaId: "financial-reporting",
    assertionIds: ["existence", "completeness", "valuation", "rights"],
    processIds: ["proc-month-end-close", "proc-intercompany"],
    material: true,
    significant: false,
  },
  {
    id: "cotabd-fr-disclosure",
    name: "Financial statement disclosures",
    type: "disclosure",
    fsaId: "financial-reporting",
    assertionIds: ["completeness", "accuracy", "presentation"],
    processIds: ["proc-month-end-close"],
    material: false,
    significant: false,
  },
];
